import { ActionProcessMode } from '@infotech-soe/metaschema';

import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';
import { UserInteractor, UserInteractorType } from '../UserInteractor';

import CategoryCommandImpl from './CategoryCommandImpl';

class ActionHistoryCommandImpl extends CategoryCommandImpl<
  Record<string, any>
> {
  constructor() {
    super();
  }

  public async execute(): Promise<void> {
    return;
  }

  public getUserInteractor(): UserInteractor {
    return {
      type: UserInteractorType.SHOW_CATEGORY,
      category: 'BusinessProcessesHistory',
      displayMode: 'view',
      action: '',
      dataset: 'BusinessProcessesHistory',
      multiSelect: false,
      hideTree: true,
      fullHierarchy: true,
      hideCheckbox: true,
    };
  }

  public async getInitialArgs(
    context: ClientContext
  ): Promise<Record<string, any>> {
    return {
      inParams: {
        document: context.get('Id'),
        category: context.get('Category'),
      },
    };
  }

  public getName(): CommandName {
    return 'actionHistory';
  }

  public getProcessMode(): ActionProcessMode {
    return 'Current';
  }
}

export default ActionHistoryCommandImpl;
